<template>
  <div class="course">
    <div class='course_top'>
        <div class='star_l'>
        </div>
        <div class='m_course_title'>搜券教程</div>
        <div class='star_r'>
        </div>
      </div>
      <div class="course_btm">
        <img src="../../images/IMG_1809_00.png"  class="course_img"/>
        <img src="../../images/IMG_1809_02.png"  class="course_img" />
        <img src="../../images/IMG_1809_03.png"  class="course_img" />
        <img src="../../images/IMG_1809_04.png"  class="course_img" />
        <img src="../../images/IMG_1809_05.png"  class="course_img" />
      </div>
  </div>


</template>
<script type = "text/ecamscript-6">
/* eslint-disable */
  export default {
    name:"sourse"
  }
</script>
<style lang="stylus">
.course
  background:#fff
  .course_top
    width: 220px
    padding: 20px 0 40px 0
    display: flex
    justify-content: space-between
    align-items:center
    margin:0 auto
    .star_l,.star_r
      width: 16px
      height: 16px
      display: block
      background:#e5e5e5
      border-radius:8px
    .m_course_title
      font-size: 30px
      height: 40px
      line-height: 40px
      color: #333
      vertical-align: top
  .course_btm
    .course_img
      width:100%

</style>



// WEBPACK FOOTER //
// src/components/search/course.vue